import axios, { AxiosInstance } from 'axios';

// Erstellen Sie eine Axios-Instanz mit voreingestellten Konfigurationen
const apiClient: AxiosInstance = axios.create({
  baseURL: '/', // Basis-URL für alle Anfragen
  headers: {
    'Content-Type': 'application/json', // Standard-Content-Type
    // Weitere globale Header hier hinzufügen
  },
});

export default apiClient;
